import { DEFAULT_PERMISSIONS } from '@/constants/constants';
import { Category } from '@/Interface/category';
import { CategoryById } from '@/Interface/categorybyid';
import { Source } from '@/Interface/source';
import { CategoryModel } from '@/model/catlist';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PermissionsService } from '@services/permissions.service';
import { UtilityService } from '@services/utility.service';
import Swal from "sweetalert2";

@Component({
    selector: 'app-category',
    templateUrl: './category.component.html',
    styleUrls: ['./category.component.scss']
})
export class CategoryComponent implements OnInit {
    categoryForm: FormGroup;
    categoryadd: FormGroup;

    categoryupdate: CategoryById;
    categoryList: Category[];
    categoryEdit = new CategoryModel();
    getSourceList: Source;
    categoryid: number;
    loader: boolean;
    // Separate from `loader`: this one is scoped to the table, so a filter,
    // a search keystroke or a page change no longer blanks the whole page.
    tableLoader: boolean = false;
    permissions = { ...DEFAULT_PERMISSIONS };
    permissionsReady: boolean = false;
    constructor(
        private modalService: NgbModal,
        private _utilitySevice: UtilityService,
        private permService: PermissionsService,
        private formbuilder: FormBuilder
    ) { }

    ngOnInit(): void {
        this.initComponent()
    }
    async initComponent() {
  this.loader=true
        this.loader = true
        await this.getComponentPermissions();

        this.categoryadd = this.formbuilder.group({
            categoryNameAdd: new FormControl(null, Validators.required),
            sourceNameAdd: new FormControl(null, Validators.required)
        });

        this.categoryForm = this.formbuilder.group({
            categoryName: new FormControl(null, Validators.required),
            sourceName: new FormControl(null, Validators.required)
        });
        if (this.permissions.canView) {
            this.getSourceName();
            this.getCategory();
        }
        setTimeout(() => {
            this.loader = false
        }, 250);
    }

    async getComponentPermissions() {
    const url = this.permService.getCurrentUrl();
    // const menuFromLocal = this.permService.loadMenuFromLocalStorage();
    const menuFromLocal = await this.permService.waitForMenuInLocalStorage();

    const matchedMenu = this.permService.findMenuPermissions(menuFromLocal, url);

    this.permissions = matchedMenu
      ? {
        canAdd: !!matchedMenu.canAdd,
        canEdit: !!matchedMenu.canEdit,
        canView: !!matchedMenu.canView,
        canDelete: !!matchedMenu.canDelete
      }
      : { ...DEFAULT_PERMISSIONS };

    this.permissionsReady = true;
  }
    get hasAnyActionPermission(): boolean {
        return (
            this.permissionsReady &&
            (this.permissions.canView ||
                this.permissions.canEdit ||
                this.permissions.canDelete)
        );
    }
    open(item: Category, content: any) {
        // this.categoryid = item.id;
        var sendIdCat = item.id;
        this._utilitySevice.selectCategoryRow(sendIdCat).subscribe((res) => {
            if (res) {
                this.categoryupdate = res[0];
                this.categoryForm.patchValue({
                    categoryName: this.categoryupdate.getCatName(),
                    sourceName: this.categoryupdate.getSouceId()
                });
            }
        });
        this.modalService.open(content);
    }

    getCategory() {
        this.tableLoader = true;
        this._utilitySevice.receiveCategory().subscribe(
            (res) => {
                if (res) {
                    this.categoryList = res;
                }
                this.tableLoader = false;
            },
            () => (this.tableLoader = false)
        );
    }

    getSourceName() {
        this._utilitySevice.receiveSourceName().subscribe((res) => {
            if (res) {
                this.getSourceList = res;
            }
        });
    }

    categorySubmit() {
        this.categoryEdit.id = this.categoryupdate.id;
        this.categoryEdit.category_name = this.categoryForm.value.categoryName;
        this.categoryEdit.source_id = this.categoryForm.value.sourceName;

        this._utilitySevice
            .updateCategory(this.categoryEdit)
            .subscribe((res) => {
                if (res) {
                    this.getCategory();
                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: '`<h2>Category  Successfully Updated</h2>`',
                        showConfirmButton: false,
                        timer: 1500
                    })

                }
            });
    }

    delateCategory(item: Category) {
        var id = item.getId();
        Swal.fire({
            title: 'Are you sure to delete this Category?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                this._utilitySevice.deleteCategory(id).subscribe((res) => {
                    if (res) {
                        this.getCategory();

                    }
                });
                Swal.fire(
                    'Deleted!',
                    'Category has been deleted.',
                    'success',

                )
            }
        })

    }

    addCategory(contentadd: any) {
        this.modalService.open(contentadd);
    }

    categoryAddSubmit() {
        this.categoryEdit.category_name =
            this.categoryadd.value.categoryNameAdd;
        this.categoryEdit.source_id = this.categoryadd.value.sourceNameAdd;

        this._utilitySevice
            .updateCategory(this.categoryEdit)
            .subscribe((res) => {
                if (res) {

                    this.getCategory();
                    this.categoryadd.reset();
                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: '`<h2>Category Successfully Added</h2>`',
                        showConfirmButton: false,
                        timer: 1500
                    })
                }
            });
    }
}
